import BaseService from "../baseServiceOrganization";
class Empresas extends BaseService {
  constructor(id) {
    const resource = "empresas";
    let relationship = {};
    super(id, relationship, resource);
  }
}

export default (id) => new Empresas(id);
